import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { PublicCreativeUnitPackageListing } from '../../../../../../api/src/creative-unit-package-listing/creative-unit-package-listing.entity';

export interface CreativeUnitPackageListingState extends EntityState<PublicCreativeUnitPackageListing> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({
	name: 'creative-unit-package-listing'
})
export class CreativeUnitPackageListingStore extends EntityStore<CreativeUnitPackageListingState> {
	constructor() {
		super();
	}
}
